import React from 'react';
import { Button } from 'carbon-components-react';

export const GroupButton = (props) => {
    return (
        <Button className="btn-margin-message" kind={props.kind} outline onClick={props.onClick} >{props.children}</Button>

    );
}
